import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import BreadCrumb from "../../components/common/bread-crumb";
import axios from "axios";
import ConfigData from '../../config.json';
import { Col, Container, Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";
import EmployeeGeneral from "../../components/employee/employee_general";
import { modelEmpGeneral, modelEmpEductaion, modelEmpFamily, modelEmpWorkInfo, modelEmpWorkExp} from "../../components/employee/model_employee";
import EmployeePersonal from "../../components/employee/employee_personal";
import EmployeeWork from "../../components/employee/employee_work";
import Swal from "sweetalert2";
import { handlerRespError } from "../../components/utility/handler_resp";

const EmployeeInfo = () => {
    const { id } = useParams();
    const history = useHistory();
    const [dataGeneral, setDataGeneral] = useState(modelEmpGeneral);
    const [dataEducation, setDataEducation] = useState([]);
    const [dataFamily, setDataFamily] = useState([]);
    const [dataWorkInfo, setDataWorkInfo] = useState(modelEmpWorkInfo);
    const [dataWorkExp, setDataWorkExp] = useState([]);
    const [breadCrumb, setBreadCrumb] = useState({ title: "", pageTitle: "" });
    const [customActiveTab, setcustomActiveTab] = useState("1");

    useEffect(() => {
        if(parseInt(id) > 0){
            setBreadCrumb({ title: "Employee information", pageTitle: "Employee management" });
            LoadDataEmpGeneral(id);
            LoadDataEmpEducation(id);
            LoadDataEmpFamily(id);
            LoadDataEmpWorkInfo(id);
            LoadDataEmpWorkExp(id);
            // let data = modelEmpGeneral;
            // data.name_th = "test";
            // data.birth_date = "1991-06-21";
            // data.address = "112 moo 2";
            // setDataGeneral(data);
            // let arrDataEducation = [];
            // let objE = modelEmpEductaion;
            // objE.id_institution = "1";
            // objE.id_level_education = "1";
            // objE.graduate_year = "2556";
            // objE.gpa = "2";
            // arrDataEducation.push(objE);
            // let objE1 = modelEmpEductaion;
            // objE1.id_institution = "1";
            // objE1.id_level_education = "2";
            // objE1.graduate_year = "2553";
            // objE1.gpa = "4";
            // arrDataEducation.push(objE1);
            // setDataEducation(arrDataEducation);
            // let arrDataFamily = [];
            // arrDataFamily.push(modelEmpFamily);
            // setDataFamily(arrDataFamily);

            // let dataWorkInfo = modelEmpWorkInfo;
            // dataWorkInfo.email = "test@btsgroup.co.th";
            // setDataWorkInfo(dataWorkInfo);

            // let arrDataWorkExp = [];
            // let objWE = modelEmpWorkExp;
            // objWE.company_name = "test";
            // arrDataWorkExp.push(objWE);
            // setDataWorkExp(arrDataWorkExp);
        }else{
            setBreadCrumb({ title: "", pageTitle: "Create new employee" });
            setDataGeneral(modelEmpGeneral);
            let arrDataEducation = [];
            arrDataEducation.push(modelEmpEductaion);
            setDataEducation(arrDataEducation);
            let arrDataFamily = [];
            arrDataFamily.push(modelEmpFamily);
            setDataFamily(arrDataFamily);
            setDataWorkInfo(modelEmpWorkInfo);
            let arrDataWorkExp = [];
            arrDataWorkExp.push(modelEmpWorkExp);
            setDataWorkExp(arrDataWorkExp);
        }
    }, []);

    const toggleCustomActiveTab = (tab) => {
        if (customActiveTab !== tab) {
            setcustomActiveTab(tab);
        }
    };

    const onSaveEmployeeGeneral = (values, file) => {
        let url = ConfigData.API_URL + "employee-general/";
        let token = "Bearer " + sessionStorage.getItem("token");
        let userId = sessionStorage.getItem("uid");
        let data = MapValueForSave(dataGeneral ,values);
        if(data.id > 0){
            url = url + data.id;
            axios.put(url, data, { headers: { 
                'Authorization' : token,
                'User': userId,
            }, responseType: "json" })
            .then(resp => {
                let respData = resp.data;
                if(respData.is_sucess === true && respData.data.length > 0){
                    if(file != null){
                        url = ConfigData.API_URL + "employee-general/" + data.id + "/pic";
                        console.log(file);
                        console.log(url);
                        const formData = new FormData();
                        formData.append("file", file)
                        axios.put(url, formData, { headers: { 
                            'Content-Type': 'multipart/form-data',
                            'Authorization' : token,
                            'User': userId,
                        }, responseType: "json" })
                        .then(resp => {
                            let respData = resp.data;
                            if(respData.is_sucess === true && respData.data.length > 0){
                                setDataGeneral(respData.data[0]);
                                Swal.fire({
                                    icon: 'success',
                                    title: 'Data saved.',
                                    confirmButtonColor: '#3085d6',
                                });
                            }
                        })
                        .catch(error => {
                            handlerRespError(error, history);
                            Swal.fire({
                                icon: 'error',
                                title: 'Failed to save data.',
                                confirmButtonColor: '#3085d6',
                            });
                            
                        });
                    }else{
                        setDataGeneral(respData.data[0]);
                        Swal.fire({
                            icon: 'success',
                            title: 'Data saved.',
                            confirmButtonColor: '#3085d6',
                        });
                    }
                }
            })
            .catch(error => {
                handlerRespError(error, history);
                Swal.fire({
                    icon: 'error',
                    title: 'Failed to save data.',
                    confirmButtonColor: '#3085d6',
                });
                
            });
        }else{
            axios.post(url, data, { headers: { 
                'Authorization' : token,
                'User': userId,
            }, responseType: "json" })
            .then(resp => {
                let respData = resp.data;
                if(respData.is_sucess === true && respData.data.length > 0){
                    if(file != null){
                        url = ConfigData.API_URL + "employee-general/" + respData.data[0].id + "/pic";
                        const formData = new FormData();
                        formData.append("file", file)
                        axios.put(url, formData, { headers: { 
                            'Content-Type': 'multipart/form-data',
                            'Authorization' : token,
                            'User': userId,
                        }, responseType: "json" })
                        .then(resp => {
                            let respData = resp.data;
                            if(respData.is_sucess === true && respData.data.length > 0){
                                Swal.fire({
                                    icon: 'success',
                                    title: 'Data saved.',
                                    confirmButtonColor: '#3085d6',
                                });
                                history.push("/employee");
                            }
                        })
                        .catch(error => {
                            handlerRespError(error, history);
                            Swal.fire({
                                icon: 'error',
                                title: 'Failed to save data.',
                                confirmButtonColor: '#3085d6',
                            });
                            
                        });
                    }else{
                        Swal.fire({
                            icon: 'success',
                            title: 'Data saved.',
                            confirmButtonColor: '#3085d6',
                        });
                        history.push("/employee");
                    }
                }
            })
            .catch(error => {
                handlerRespError(error, history);
                Swal.fire({
                    icon: 'error',
                    title: 'Failed to save data.',
                    confirmButtonColor: '#3085d6',
                });
            });
        }
    };

    const onSaveEmployeePersonal = (values) => {
        let data = values;
        data.profile = MapValueForSave(dataGeneral ,values.profile);
        let isSaveSucess = true;
        if(data.profile.id > 0){
            (async () => {
                let isSaveEmpGeneral = await UpdateEmpGeneral(data.profile);
                isSaveSucess = (isSaveEmpGeneral === true && isSaveSucess === true) ? true : false;

                for(let i = 0; i < data.education.length; i++){
                    let isSaveEmpEducation = true;
                    let objEducation = data.education[i];
                    objEducation.id_employee_general = data.profile.id;
                    objEducation.employee_id = data.profile.employee_id;
                    objEducation.id_level_education = (objEducation.id_level_education !== "") ? parseInt(objEducation.id_level_education) : 0;
                    objEducation.id_institution = (objEducation.id_institution !== "") ? parseInt(objEducation.id_institution) : 0;
                    if(objEducation.id > 0){
                        if(objEducation.status === "1"){
                            isSaveEmpEducation = await UpdateEmpEducation(objEducation);
                            isSaveSucess = (isSaveEmpEducation === true && isSaveSucess === true) ? true : false;
                        }else{
                            isSaveEmpEducation = await DeleteEmpEducation(objEducation);
                            isSaveSucess = (isSaveEmpEducation === true && isSaveSucess === true) ? true : false;
                        }
                    }else if(objEducation.id === 0 && objEducation.status === "1"){
                        isSaveEmpEducation = await AddEmpEducation(objEducation);
                        isSaveSucess = (isSaveEmpEducation === true && isSaveSucess === true) ? true : false;
                    }
                }

                for(let i = 0; i < data.family.length; i++){
                    let isSaveEmpFamily = true;
                    let objFamily = data.family[i];
                    objFamily.id_employee_general = data.profile.id;
                    objFamily.employee_id = data.profile.employee_id;
                    if(objFamily.id > 0){
                        if(objFamily.status === "1"){
                            isSaveEmpFamily = await UpdateEmpFamily(objFamily);
                            isSaveSucess = (isSaveEmpFamily === true && isSaveSucess === true) ? true : false;
                        }else{
                            isSaveEmpFamily = await DeleteEmpFamily(objFamily);
                            isSaveSucess = (isSaveEmpFamily === true && isSaveSucess === true) ? true : false;
                        }
                    }else if(objFamily.id === 0 && objFamily.status === "1"){
                        isSaveEmpFamily = await AddEmpFamily(objFamily);
                        isSaveSucess = (isSaveEmpFamily === true && isSaveSucess === true) ? true : false;
                    }
                }
                
                if(isSaveSucess === true){
                    LoadDataEmpGeneral(data.profile.id);
                    LoadDataEmpEducation(data.profile.id);
                    LoadDataEmpFamily(data.profile.id);
                    Swal.fire({
                        icon: 'success',
                        title: 'Data saved.',
                        confirmButtonColor: '#3085d6',
                    });
                }else{
                    Swal.fire({
                        icon: 'error',
                        title: 'Failed to save data.',
                        confirmButtonColor: '#3085d6',
                    });
                }
            })();
        }
    };

    const onSaveEmployeeWork= (values) => {
        // console.log(values);
        let data = values;
        let isSaveSucess = true;
        if(data.general.id > 0){
            (async () => {
                let isSaveEmpWorkInfo = true;
                let objWorkInfo = data.work_info;
                objWorkInfo.id_employee_general = data.general.id;
                objWorkInfo.employee_id = data.general.employee_id;
                objWorkInfo.id_business_unit = (objWorkInfo.id_business_unit !== "") ? parseInt(objWorkInfo.id_business_unit) : 0;
                objWorkInfo.id_department = (objWorkInfo.id_department !== "") ? parseInt(objWorkInfo.id_department) : 0;
                objWorkInfo.id_sub_department = (objWorkInfo.id_sub_department !== "") ? parseInt(objWorkInfo.id_sub_department) : 0;
                objWorkInfo.id_division = (objWorkInfo.id_division !== "") ? parseInt(objWorkInfo.id_division) : 0;
                objWorkInfo.id_sub_division = (objWorkInfo.id_sub_division !== "") ? parseInt(objWorkInfo.id_sub_division) : 0;
                objWorkInfo.id_section = (objWorkInfo.id_section !== "") ? parseInt(objWorkInfo.id_section) : 0;
                objWorkInfo.id_sub_section = (objWorkInfo.id_sub_section !== "") ? parseInt(objWorkInfo.id_sub_section) : 0;
                objWorkInfo.id_position = (objWorkInfo.id_position !== "") ? parseInt(objWorkInfo.id_position) : 0;
                objWorkInfo.id_level_position = (objWorkInfo.id_level_position !== "") ? parseInt(objWorkInfo.id_level_position) : 0;
                objWorkInfo.id_employment_type = (objWorkInfo.id_employment_type !== "") ? parseInt(objWorkInfo.id_employment_type) : 0;
                objWorkInfo.id_cost_center = (objWorkInfo.id_cost_center !== "") ? parseInt(objWorkInfo.id_cost_center) : 0;
                objWorkInfo.supervisor = (objWorkInfo.supervisor !== "") ? parseInt(objWorkInfo.supervisor) : 0;
                objWorkInfo.one_over_one = (objWorkInfo.one_over_one !== "") ? parseInt(objWorkInfo.one_over_one) : 0;
                objWorkInfo.hod_id = (objWorkInfo.hod_id !== "") ? parseInt(objWorkInfo.hod_id) : 0;
                objWorkInfo.mentor_id = (objWorkInfo.mentor_id !== "") ? parseInt(objWorkInfo.mentor_id) : 0;
                if(objWorkInfo.id > 0){
                    isSaveEmpWorkInfo = await UpdateEmpWorkInfo(objWorkInfo);
                    isSaveSucess = (isSaveEmpWorkInfo === true && isSaveSucess === true) ? true : false;
                }else{
                    isSaveEmpWorkInfo = await AddEmpWorkInfo(objWorkInfo);
                    isSaveSucess = (isSaveEmpWorkInfo === true && isSaveSucess === true) ? true : false;
                }
                
                for(let i = 0; i < data.work_exp.length; i++){
                    let isSaveEmpWorkExp = true;
                    let objWorkExp = data.work_exp[i];
                    objWorkExp.id_employee_general = data.general.id;
                    objWorkExp.employee_id = data.general.employee_id;
                    if(objWorkExp.id > 0){
                        if(objWorkExp.status === "1"){
                            isSaveEmpWorkExp = await UpdateEmpWorkExp(objWorkExp);
                            isSaveSucess = (isSaveEmpWorkExp === true && isSaveSucess === true) ? true : false;
                        }else{
                            isSaveEmpWorkExp = await DeleteEmpWorkExp(objWorkExp);
                            isSaveSucess = (isSaveEmpWorkExp === true && isSaveSucess === true) ? true : false;
                        }
                    }else if(objWorkExp.id === 0 && objWorkExp.status === "1"){
                        isSaveEmpWorkExp = await AddEmpWorkExp(objWorkExp);
                        isSaveSucess = (isSaveEmpWorkExp === true && isSaveSucess === true) ? true : false;
                    }
                }
                
                if(isSaveSucess === true){
                    LoadDataEmpWorkInfo(data.general.id);
                    LoadDataEmpWorkExp(data.general.id)
                    Swal.fire({
                        icon: 'success',
                        title: 'Data saved.',
                        confirmButtonColor: '#3085d6',
                    });
                }else{
                    Swal.fire({
                        icon: 'error',
                        title: 'Failed to save data.',
                        confirmButtonColor: '#3085d6',
                    });
                }
            })();
        }

    };

    const onCancel = () => {
        Swal.fire({
            title: 'Are you sure ?',
            text: 'Any changes you have made will be lost.',
            showCancelButton: true,
            confirmButtonText: 'Continue',
            confirmButtonColor: '#dc3741',
        }).then((result) => {
            if(result.isConfirmed){
                history.push("/employee");
            }
        });
    };

    const LoadDataEmpGeneral = (id_emp_general) => {
        let url = ConfigData.API_URL + "employee-general/" + id_emp_general;
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                setDataGeneral(respData.data[0]);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataEmpEducation = (id_emp_general) => {
        let url = ConfigData.API_URL + "employee-education/?status=1&id_emp_general=" + id_emp_general ;
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                if(respData.data.length > 0){
                    setDataEducation(respData.data);
                }else{
                    let arrDataEducation = [];
                    arrDataEducation.push(modelEmpEductaion);
                    setDataEducation(arrDataEducation);
                }
                
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataEmpFamily = (id_emp_general) => {
        let url = ConfigData.API_URL + "employee-family/?status=1&id_emp_general=" + id_emp_general ;
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                if(respData.data.length > 0){
                    setDataFamily(respData.data);
                }else{
                    let arrDataFamily = [];
                    arrDataFamily.push(modelEmpFamily);
                    setDataFamily(arrDataFamily);
                }
                
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataEmpWorkInfo = (id_emp_general) => {
        let url = ConfigData.API_URL + "employee-work-info/?status=1&id_emp_general=" + id_emp_general ;
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                if(respData.data.length > 0){
                    setDataWorkInfo(respData.data[0]);
                }else{
                    setDataWorkInfo(modelEmpWorkInfo);
                }
                
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataEmpWorkExp = (id_emp_general) => {
        let url = ConfigData.API_URL + "employee-work-exp/?status=1&id_emp_general=" + id_emp_general ;
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                if(respData.data.length > 0){
                    setDataWorkExp(respData.data);
                }else{
                    let arrDataWorkExp= [];
                    arrDataWorkExp.push(modelEmpWorkExp);
                    setDataWorkExp(arrDataWorkExp);
                }
                
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const UpdateEmpGeneral = async (data) => {
        let url = ConfigData.API_URL + "employee-general/" + data.id;
        let token = "Bearer " + sessionStorage.getItem("token");
        let userId = sessionStorage.getItem("uid");
        try {
            const resp = await axios.put(url, data, { headers: { 
                                'Authorization' : token,
                                'User': userId,
                            }, responseType: "json" }
                        );
            let respData = resp.data;
            return respData.is_sucess;
        }catch(error){
            handlerRespError(error, history);
            return false;
        }
    };

    const AddEmpEducation = async (data) => {
        let url = ConfigData.API_URL + "employee-education/";
        let token = "Bearer " + sessionStorage.getItem("token");
        let userId = sessionStorage.getItem("uid");
        try {
            const resp = await axios.post(url, data, { headers: { 
                                'Authorization' : token,
                                'User': userId,
                            }, responseType: "json" }
                        );
            let respData = resp.data;
            return respData.is_sucess;
        }catch(error){
            handlerRespError(error, history);
            return false;
        }
    };

    const UpdateEmpEducation = async (data) => {
        let url = ConfigData.API_URL + "employee-education/" + data.id;
        let token = "Bearer " + sessionStorage.getItem("token");
        let userId = sessionStorage.getItem("uid");
        try {
            const resp = await axios.put(url, data, { headers: { 
                            'Authorization' : token,
                            'User': userId,
                        }, responseType: "json" });
            let respData = resp.data;
            return respData.is_sucess;
        }catch(error){
            handlerRespError(error, history);
            return false;
        }
    };

    const DeleteEmpEducation = async (data) => {
        let url = ConfigData.API_URL + "employee-education/" + data.id;
        let token = "Bearer " + sessionStorage.getItem("token");
        let userId = sessionStorage.getItem("uid");
        try {
            const resp = await axios.delete(url, { headers: { 
                            'Authorization' : token,
                            'User': userId,
                        }, responseType: "json" });
            let respData = resp.data;
            return respData.is_sucess;
        }catch(error){
            handlerRespError(error, history);
            return false;
        }
    };

    const AddEmpFamily= async (data) => {
        let url = ConfigData.API_URL + "employee-family/";
        let token = "Bearer " + sessionStorage.getItem("token");
        let userId = sessionStorage.getItem("uid");
        try {
            const resp = await axios.post(url, data, { headers: { 
                                'Authorization' : token,
                                'User': userId,
                            }, responseType: "json" }
                        );
            let respData = resp.data;
            return respData.is_sucess;
        }catch(error){
            handlerRespError(error, history);
            return false;
        }
    };

    const UpdateEmpFamily = async (data) => {
        let url = ConfigData.API_URL + "employee-family/" + data.id;
        let token = "Bearer " + sessionStorage.getItem("token");
        let userId = sessionStorage.getItem("uid");
        try {
            const resp = await axios.put(url, data, { headers: { 
                            'Authorization' : token,
                            'User': userId,
                        }, responseType: "json" });
            let respData = resp.data;
            return respData.is_sucess;
        }catch(error){
            handlerRespError(error, history);
            return false;
        }
    };

    const DeleteEmpFamily = async (data) => {
        let url = ConfigData.API_URL + "employee-family/" + data.id;
        let token = "Bearer " + sessionStorage.getItem("token");
        let userId = sessionStorage.getItem("uid");
        try {
            const resp = await axios.delete(url, { headers: { 
                            'Authorization' : token,
                            'User': userId,
                        }, responseType: "json" });
            let respData = resp.data;
            return respData.is_sucess;
        }catch(error){
            handlerRespError(error, history);
            return false;
        }
    };

    const AddEmpWorkInfo = async (data) => {
        let url = ConfigData.API_URL + "employee-work-info/";
        let token = "Bearer " + sessionStorage.getItem("token");
        let userId = sessionStorage.getItem("uid");
        try {
            const resp = await axios.post(url, data, { headers: { 
                                'Authorization' : token,
                                'User': userId,
                            }, responseType: "json" }
                        );
            let respData = resp.data;
            return respData.is_sucess;
        }catch(error){
            handlerRespError(error, history);
            return false;
        }
    };

    const UpdateEmpWorkInfo = async (data) => {
        let url = ConfigData.API_URL + "employee-work-info/" + data.id;
        let token = "Bearer " + sessionStorage.getItem("token");
        let userId = sessionStorage.getItem("uid");
        try {
            const resp = await axios.put(url, data, { headers: { 
                            'Authorization' : token,
                            'User': userId,
                        }, responseType: "json" });
            let respData = resp.data;
            return respData.is_sucess;
        }catch(error){
            handlerRespError(error, history);
            return false;
        }
    };

    const AddEmpWorkExp= async (data) => {
        let url = ConfigData.API_URL + "employee-work-exp/";
        let token = "Bearer " + sessionStorage.getItem("token");
        let userId = sessionStorage.getItem("uid");
        try {
            const resp = await axios.post(url, data, { headers: { 
                                'Authorization' : token,
                                'User': userId,
                            }, responseType: "json" }
                        );
            let respData = resp.data;
            return respData.is_sucess;
        }catch(error){
            handlerRespError(error, history);
            return false;
        }
    };

    const UpdateEmpWorkExp = async (data) => {
        let url = ConfigData.API_URL + "employee-work-exp/" + data.id;
        let token = "Bearer " + sessionStorage.getItem("token");
        let userId = sessionStorage.getItem("uid");
        try {
            const resp = await axios.put(url, data, { headers: { 
                            'Authorization' : token,
                            'User': userId,
                        }, responseType: "json" });
            let respData = resp.data;
            return respData.is_sucess;
        }catch(error){
            handlerRespError(error, history);
            return false;
        }
    };

    const DeleteEmpWorkExp = async (data) => {
        let url = ConfigData.API_URL + "employee-work-exp/" + data.id;
        let token = "Bearer " + sessionStorage.getItem("token");
        let userId = sessionStorage.getItem("uid");
        try {
            const resp = await axios.delete(url, { headers: { 
                            'Authorization' : token,
                            'User': userId,
                        }, responseType: "json" });
            let respData = resp.data;
            return respData.is_sucess;
        }catch(error){
            handlerRespError(error, history);
            return false;
        }
    };

    const MapValueForSave = (dataOld, dataNew) => {
        let objSave = Object.assign({}, modelEmpGeneral);
        Object.keys(objSave).forEach(function(key, index){
            if(dataNew[key] !== undefined){
                objSave[key] = dataNew[key];
            }else{
                objSave[key] = dataOld[key];
            }
        });
        return objSave;
    };

    return(
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={breadCrumb.title} pageTitle={breadCrumb.pageTitle} />
                    <Row>
                        <Col lg={12}>
                            <Nav tabs className="nav nav-tabs nav-tabs-custom nav-justified mb-3">
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            active: customActiveTab === "1",
                                        })}
                                        onClick={() => {
                                            toggleCustomActiveTab("1");
                                        }}
                                    >
                                        General information
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            active: customActiveTab === "2",
                                            disabled: id <= 0,
                                        })}
                                        onClick={() => {
                                            toggleCustomActiveTab("2");
                                        }}
                                    >
                                        Personal information
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            active: customActiveTab === "3",
                                            disabled: id <= 0,
                                        })}
                                        onClick={() => {
                                            toggleCustomActiveTab("3");
                                        }}
                                    >
                                        Work information
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent
                                activeTab={customActiveTab}
                            >
                                <TabPane tabId="1">
                                    <EmployeeGeneral data={dataGeneral} idEmpGeneral={id} onSave={onSaveEmployeeGeneral} onCancel={onCancel} />
                                </TabPane>
                                <TabPane tabId="2">
                                    <EmployeePersonal dataProfile={dataGeneral} dataEducation={dataEducation} dataFamily={dataFamily} idEmpGeneral={id} onSave={onSaveEmployeePersonal} onCancel={onCancel} />
                                </TabPane>
                                <TabPane tabId="3">
                                    <EmployeeWork dataGeneral={dataGeneral} dataWorkInfo={dataWorkInfo} dataWorkExp={dataWorkExp} idEmpGeneral={id} onSave={onSaveEmployeeWork} onCancel={onCancel} />
                                </TabPane>
                            </TabContent>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
}

export default EmployeeInfo;